import { motion } from "framer-motion";
import { Check, Plus } from "lucide-react";
import { formatBRL } from "../data/menu";

export const AddonChip = ({ item, color, active, showPrice = true, testId, onToggle }) => (
  <motion.button
    type="button"
    data-testid={testId}
    onClick={onToggle}
    whileTap={{ scale: 0.94 }}
    whileHover={{ y: -2 }}
    className={`flex items-center justify-between gap-3 rounded-2xl border px-4 py-3 text-left text-sm transition-colors duration-200 ${
      active
        ? "border-transparent font-bold text-[#1E053B]"
        : "border-purple-500/25 bg-white/5 text-purple-100 hover:border-purple-300/50 hover:bg-white/10"
    }`}
    style={active ? { backgroundColor: color } : undefined}
  >
    <span className="flex items-center gap-2">
      {active ? (
        <Check className="h-4 w-4 shrink-0" strokeWidth={3} />
      ) : (
        <Plus className="h-4 w-4 shrink-0 opacity-50" />
      )}
      <span>{item.name}</span>
    </span>
    {showPrice && (
      <span
        className={`shrink-0 font-semibold ${active ? "text-[#1E053B]" : "text-emerald-400"}`}
      >
        {formatBRL(item.price)}
      </span>
    )}
  </motion.button>
);
